// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@3778.care/goban";
import PropTypes from "prop-types";

export const ConfirmationDialog = ({
  cancelText,
  confirmText,
  dialogContent,
  isOpen,
  onConfirm,
  onToggle,
  title,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onToggle();
  };

  return (
    <Dialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      onClose={onToggle}
      open={isOpen}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

      <DialogContent>{dialogContent}</DialogContent>

      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          {confirmText}
        </Button>
        <Button onClick={onToggle} color="primary" autoFocus>
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  cancelText: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  dialogContent: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func,
  onToggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
